import { render, staticRenderFns } from "./InvestorCard.vue?vue&type=template&id=2790ac96&scoped=true&"
import script from "./InvestorCard.vue?vue&type=script&lang=js&"
export * from "./InvestorCard.vue?vue&type=script&lang=js&"
import style0 from "./InvestorCard.vue?vue&type=style&index=0&id=2790ac96&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2790ac96",
  null
  
)

export default component.exports